import createApi from "../utils/apiClient";
const api = createApi();

export const getMenu = () => async (dispatch) => {
  try {
    dispatch({ type: "MENU_REQUEST" });
    const { data } = await api.get("/canteen/menu");
    dispatch({ type: "MENU_SUCCESS", payload: data.menu });
  } catch (err) {
    dispatch({ type: "MENU_FAIL", payload: err.response?.data?.message });
  }
};
export const getOrders = () => async (dispatch) => {
  try {
    const { data } = await api.get("/canteen/orders");
    dispatch({ type: "ORDERS_SUCCESS", payload: data.orders });
  } catch (err) {}
};
export const addMenuItem = (d) => async (dispatch) => {
  try {
    await api.post("/canteen/menu", d);
    dispatch(getMenu());
  } catch (err) {
    throw err;
  }
};
export const updateMenuItem = (id, d) => async (dispatch) => {
  try {
    await api.put(`/canteen/menu/${id}`, d);
    dispatch(getMenu());
  } catch (err) {
    throw err;
  }
};
export const deleteMenuItem = (id) => async (dispatch) => {
  try {
    await api.delete(`/canteen/menu/${id}`);
    dispatch(getMenu());
  } catch (err) {
    throw err;
  }
};
export const placeOrder = (d) => async (dispatch) => {
  try {
    const r = await api.post("/canteen/orders", d);
    dispatch(getOrders());
    return r.data;
  } catch (err) {
    throw err;
  }
};
